export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_rpg-chemicals/artifacts/5dzwsec5_Screenshot%202026-06-28%20at%206.05.03%E2%80%AFPM.png";

export const COMPANY = {
  name: "RPG Rasayan Udyog Limited",
  shortName: "RPG Rasayan Udyog Ltd",
  tagline: "50 Years of Chemical Legacy — Now Manufacturing Plasticisers.",
  email: "info@rpgrasayanudyogltd.com",
  phone: "+91-92310-63907",
  address: "Kolkata, West Bengal, India",
  parentLegacyYears: 50,
  capacityNow: "30,000",
  capacityFuture: "50,000",
  expansionYears: 3,
};

export const PRODUCTS = [
  {
    code: "DOTP",
    name: "Dioctyl Terephthalate",
    brandName: "Rasaflex 8080",
    image: "/images/dotp-drum.jpeg",
    cas: "6422-86-2",
    description:
      "Phthalate-free general-purpose plasticiser — a safer modern replacement for DOP across PVC compounds.",
    applications: [
      "Wires & cables",
      "Flooring & wall coverings",
      "Footwear",
      "Toys & consumer goods",
      "Medical-grade tubing",
    ],
    packaging: "210 kg drums, 1000 kg IBC totes, ISO tank lorries, flexi-bags",
  },
  {
    code: "DOP",
    name: "Dioctyl Phthalate",
    cas: "117-81-7",
    description:
      "The industry workhorse plasticiser delivering high efficiency, excellent compatibility with PVC, and balanced mechanical performance at competitive cost.",
    applications: [
      "PVC compounds",
      "Flooring",
      "Coated fabrics",
      "Adhesives & sealants",
      "Cable insulation",
    ],
    packaging: "210 kg drums, IBC totes, road tankers, ISO tanks",
  },
  {
    code: "DINP",
    name: "Diisononyl Phthalate",
    cas: "28553-12-0",
    description:
      "High-molecular-weight plasticiser with reduced volatility and superior permanence. Preferred for long-life flexible PVC applications.",
    applications: [
      "Automotive interiors",
      "Construction profiles & membranes",
      "Tarpaulins",
      "Synthetic leather",
      "Packaging films",
    ],
    packaging: "210 kg drums, 1000 kg IBC totes, ISO tanks",
  },
  {
    code: "TOTM",
    name: "Trioctyl Trimellitate",
    cas: "3319-31-1",
    description:
      "High-performance trimellitate plasticiser engineered for high-temperature, low-migration applications where permanence is critical.",
    applications: [
      "High-temperature wires & cables",
      "Automotive under-the-hood components",
      "Medical devices",
      "Specialty films",
    ],
    packaging: "210 kg drums, IBC totes",
  },
];

export const INDUSTRIES = [
  {
    name: "Wires & Cables",
    blurb:
      "Flexible PVC insulation and sheathing compounds engineered for thermal stability and long service life.",
    icon: "Cable",
  },
  {
    name: "PVC Flooring & Wall Coverings",
    blurb:
      "Durable, low-migration plasticisers for resilient flooring, vinyl tiles, and wall coverings.",
    icon: "LayoutGrid",
  },
  {
    name: "Footwear",
    blurb:
      "PVC soles, straps, and synthetic leather uppers — soft touch, abrasion-resistant performance.",
    icon: "Footprints",
  },
  {
    name: "Automotive Interiors",
    blurb:
      "Dashboards, door panels, wire harnesses, and seat coverings designed for OEM-grade durability.",
    icon: "Car",
  },
  {
    name: "Medical Devices & Tubing",
    blurb:
      "Pharma-grade flexible PVC and tubing applications with controlled migration profiles.",
    icon: "Stethoscope",
  },
  {
    name: "Packaging Films",
    blurb:
      "Cling films, stretch wraps, and flexible packaging where clarity and flexibility matter.",
    icon: "Package",
  },
  {
    name: "Adhesives & Sealants",
    blurb:
      "Industrial adhesives, plastisols, and sealant formulations requiring tailored viscosity.",
    icon: "Layers",
  },
  {
    name: "Coated Fabrics & Tarpaulins",
    blurb:
      "Heavy-duty PVC-coated fabrics, tarpaulins, banners, and architectural membranes.",
    icon: "Tent",
  },
  {
    name: "Toys & Consumer Goods",
    blurb:
      "Phthalate-free DOTP solutions compliant with global safety standards for children's products.",
    icon: "ToyBrick",
  },
  {
    name: "Construction Materials",
    blurb:
      "PVC pipes, profiles, waterproofing membranes, and construction-grade flexible compounds.",
    icon: "HardHat",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "RPG Rasayan Udyog's DOTP delivers very consistent batch-to-batch performance across our four extrusion lines. The shift cut our scrap rate and stabilised compound viscosity within the first month of switching.",
    author: "Rajeev Mukherjee",
    role: "Head — Procurement",
    org: "Pragati Cables Pvt Ltd",
  },
  {
    quote:
      "Their phthalate-free DOTP let us meet European toy-safety norms for export orders without changing our PVC sole recipe. Reliable supply and clean COAs every shipment.",
    author: "Anjali Krishnan",
    role: "Plant Director",
    org: "Veerashakti Footwear Industries",
  },
  {
    quote:
      "Port-linked feedstock advantage translated into a meaningful landed-cost saving versus our previous supplier — and lead times have dropped from 14 days to under a week.",
    author: "Arvind Shetty",
    role: "Supply Chain Lead",
    org: "Shakti Polymers & Compounders Ltd",
  },
  {
    quote:
      "TOTM permanence is critical for our high-temperature automotive cable programme. RPG Rasayan Udyog has been a dependable single-source partner for the last several batches.",
    author: "Dr. Suman Banerjee",
    role: "Technical Manager",
    org: "Indravati Auto Cables Pvt Ltd",
  },
  {
    quote:
      "We evaluated their DINP for our tarpaulin and coated-fabric range — low volatility, excellent permanence, and tankers always arrive on schedule. Easy supplier to work with.",
    author: "Mohammed Iqbal",
    role: "Operations Head",
    org: "Maithri Coated Fabrics Pvt Ltd",
  },
  {
    quote:
      "Their technical team helped us re-tune our medical-grade PVC compound to meet a customer's migration spec. The hand-holding made the qualification cycle painless.",
    author: "Kavitha Iyer",
    role: "QA Manager",
    org: "Avanti Medical Polymers Ltd",
  },
];

export const TRUSTED_END_BRANDS = [
  {
    sector: "Wires & Cables",
    brands: [
      "Polycab",
      "Havells",
      "Finolex",
      "KEI Industries",
      "RR Kabel",
      "Apar Industries",
      "Skipper",
      "V-Guard",
    ],
  },
  {
    sector: "Footwear",
    brands: ["Bata", "Liberty", "Relaxo", "Action", "Paragon", "Khadim's"],
  },
  {
    sector: "Pipes & Construction",
    brands: [
      "Astral",
      "Supreme",
      "Finolex Pipes",
      "Prince Pipes",
      "Ashirvad",
      "Kisan Mouldings",
    ],
  },
  {
    sector: "Automotive",
    brands: [
      "Tata Motors",
      "Mahindra",
      "Maruti Suzuki",
      "Bajaj Auto",
      "Hero MotoCorp",
    ],
  },
  {
    sector: "Packaging & Films",
    brands: ["Uflex", "Cosmo First", "Jindal Poly Films", "SRF", "Polyplex"],
  },
  {
    sector: "Medical Devices",
    brands: ["Romsons", "Poly Medicure", "Eastern Medikit", "Sutures India"],
  },
];

export const HERO_IMAGE = "/images/jetty-loading.jpeg";

export const PLANT_IMAGE = "/images/plant-tower.jpeg";

export const ABOUT_IMAGE = "/images/fleet-drums.jpeg";

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/products", label: "Products" },
  { to: "/industries", label: "Industries" },
  { to: "/contact", label: "Contact" },
];
